// B5 ③ 위치·확인 — 주소 검색/지도 핀 · 상세 위치 · 참고 링크 · 메모 · 요약 · 검차비 · 제출.
// 위치는 링크나 첨부가 있으면 비워도 된다(서버 규칙 — 앱 #22·#37 정합).
import React from 'react';
import { T, R } from '../../../theme';
import LtrText from '../../parts/LtrText';
import MoneyKRW from '../../parts/MoneyKRW';
import { Field, NoteBox, CtaBar, input, textarea, btnNavy, btnPlain, btnDisabled } from './bits';

var picks = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 };
var pickBtn = { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: 36, padding: '0 10px',
  borderRadius: R.md, border: '1px solid ' + T.bd, background: T.card, color: T.body, fontSize: 12.5,
  fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', minWidth: 0 };
var sum = { border: '1px solid ' + T.bd, borderRadius: R.card, background: T.head, overflow: 'clip' };
var srow = { display: 'flex', alignItems: 'center', gap: 10, padding: '9px 13px', borderBottom: '1px solid ' + T.bdSoft, minWidth: 0 };
var srowLast = Object.assign({}, srow, { borderBottom: 0 });
var sl = { fontSize: 11.5, color: T.muted, flex: 'none' };
var sv = { marginInlineStart: 'auto', fontSize: 12.5, fontWeight: 700, color: T.ink, minWidth: 0,
  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'end' };

function Row(props) {
  return (<div style={props.last ? srowLast : srow}>
    <span style={sl}>{props.label}</span>
    <span style={sv}>{props.children}</span>
  </div>);
}

function StepLocation(props) {
  var t = props.t;
  var f = props.form;
  var set = props.onChange;

  return (<React.Fragment>
    <Field label={t('evalFormLocation')} required htmlFor="req-location" error={props.locationError}>
      <input id="req-location" style={input} value={f.location} placeholder={t('evalFormLocationHint')}
        onChange={function (e) { set('location', e.target.value); }} />
    </Field>
    <div style={picks}>
      <button type="button" style={pickBtn} data-testid="pick-map" onClick={props.onPickMap}>{t('simplePickMap')}</button>
      <button type="button" style={pickBtn} data-testid="pick-addr" onClick={props.onPickAddr}>{t('simplePickAddr')}</button>
    </div>

    <Field label={t('evalFormLocationDetail')} htmlFor="req-locdetail">
      <input id="req-locdetail" style={input} value={f.location_detail} placeholder={t('simpleLocDetailHint')}
        onChange={function (e) { set('location_detail', e.target.value); }} />
    </Field>

    <Field label={t('simpleB3RefLink')} htmlFor="req-reflink" error={props.urlError}>
      <input id="req-reflink" type="url" dir="ltr" style={input} value={f.listing_url} placeholder="https://"
        onChange={function (e) { set('listing_url', e.target.value); }} />
    </Field>

    <Field label={t('simpleMemoLabel')} htmlFor="req-memo">
      <textarea id="req-memo" style={textarea} rows={2} value={f.memo} placeholder={t('simpleMemoHint')}
        onChange={function (e) { set('memo', e.target.value); }} />
    </Field>
    <NoteBox><div>{t('simpleMemoLangNote')}</div></NoteBox>

    <div style={sum}>
      <Row label={t('simpleStepMethod')}>{props.methodLabel}</Row>
      <Row label={t('evalFormModel')}>{f.car_model || '-'}</Row>
      <Row label={t('evalFormCarNumber')}><LtrText>{f.car_number || '-'}</LtrText></Row>
      <Row label={t('evalFormLocation')}>{f.location || '-'}</Row>
      <Row label={t('evalFormListingUrl')}><LtrText>{props.listingHost || '-'}</LtrText></Row>
      <Row label={t('evalFormFee')} last><MoneyKRW won={props.fee} /></Row>
    </div>
    <NoteBox><div>{t('simpleSchedNote')}</div></NoteBox>

    <CtaBar isMobile={props.isMobile}>
      <button type="button" style={props.isMobile ? Object.assign({}, btnPlain, { flex: 1 }) : btnPlain}
        onClick={props.onBack}>{t('actionBack')}</button>
      <button type="button" data-testid="submit-cta" disabled={props.submitting}
        style={props.submitting ? Object.assign({}, btnNavy, btnDisabled, { flex: 2 }) : Object.assign({}, btnNavy, props.isMobile ? { flex: 2 } : null)}
        onClick={props.onSubmit}>{t('simpleSubmit')}</button>
    </CtaBar>
  </React.Fragment>);
}

export default StepLocation;
